//EXTERNAL
import React from "react"
//COMPONENTS
import BouncingIcon from "../../BouncingIcon"
//ASSETS
import helloArticleHero from "../../../assets/hello-article-hero.jpg"
import "../Article.css"
import "./HelloArticle.css"
//FUNCTIONS

export default function HelloArticleMobile(format) {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "flex-column",
        justifyContent: "center",
        minWidth: "320px"
      }}>
      <div
        style={{
          backgroundColor: "white",
          overflowX: "hidden",
          overflowY: "scroll"
        }}>
        <img src={helloArticleHero} className="w-100" alt={"article-header"} />
        <div className="serif" style={{ marginLeft: "10px", marginRight: "10px" }}>
          <div className="hello-article-content">
            <h2 className="hello-article-title tl mh3">Beauty Receipts: What Niomi Smart’s £445 monthly beauty routine looks like</h2>
            <p className="hello-intro tl mh3 mv3">Discover the products she swears by and the cost of her beauty routine.</p>
            <BouncingIcon />
            <div className="hello-article-body">
              <p className="mt1 mh3 f6">
                <span className="hello-article-content-first-letter">W</span>elcome to Beauty Receipts, where each fortnight, we ask interesting women to give us a glimpse into their beauty routines, from what they splurge and save on, to their top makeup and skincare tips. Intrigued? Read on for the products that make the cut for influencer Niomi Smart…
              </p>
              <p className="hello-article-subtitle mh3">Niomi Smart’s skincare routine</p>
              <p className="mt1 mh3 f6">
                “My morning and evening routines are very similar actually – I start the day using the Smart Skin Purifying Golden Jelly Cleanser, £24, which turns to oil when you mix it with warm water, and I use it again at night to remove any makeup or dirt. Then I use the Smart Skin Super C Moisturiser, £28, which contains Superox C, a really unique ingredient that is incredibly hydrating. I think moisturising is one of the most important things you can do for your skin, so I try to do it as
                often as possible. I’ve been working on my Smart Skin brand and using the products for two years now and I am completely hooked. We really took our time developing each product, considering every single ingredient - asking what the benefits are, how do they work, are they natural and can they be sourced in a way that’s sustainable.”
              </p>
              <p className="mt1 mh3 f6">“My best skincare tip has been passed down from my great-grandma to my grandma, to my mum and now to me! The tip is to always be extra careful with the skin around the eyes. I’m always cautious to take my time applying and removing eye makeup and to never ever stretch that area of skin. It is just so delicate!”</p>
              <p className="b mt1 mh3 mb3">Total: £52</p>
              <div className="ad-creative flex flex-row justify-center">{format}</div>
              <p className="hello-article-subtitle mh3">Niomi Smart’s hair care routine</p>
              <p className="mt1 mh3 f6">“I typically wash my hair twice a week. I’m not particularly regimented with it, it’s just when I feel I need to, because it takes quite a while to do. I love the Living Proof range, Living Proof Shampoo £19; Living Proof Conditioner £19 – the products are silicone free and smell amazing. Plus I find they work really well at taming my naturally frizzy hair, even without applying any heat or extra styling products."</p>
              <p className="mt1 mh3 f6">“I generally leave my hair to dry and style naturally, but when I have time I’ll use my ghd Straighteners, £109, to create some subtle waves which tend to last a couple of days. Then at night, I put my hair in a plait to maintain the waves for the next day.”</p>
              <p className="b mt1 mh3 mb4">Total: £147</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
